import { memo } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { DEFAULT_MONEY_REACT_NUMBER_FORMAT_PROPS } from './constants';
import { InputText } from '../input-text';

type InputMoneyProps = { label?: string; sx?: any } & NumericFormatProps;

export const InputMoney = memo<InputMoneyProps>(function InputMoney(props) {
  const showEmptyMask =
    props.displayType === 'text' &&
    (props.value === null || props.value === undefined);

  return (
    <NumericFormat
      {...DEFAULT_MONEY_REACT_NUMBER_FORMAT_PROPS}
      customInput={InputText}
      size={'small'}
      variant="outlined"
      {...(props as any)}
      value={showEmptyMask ? '-' : props.value}
    />
  );
});

export default InputMoney;
